import {Inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {DOCUMENT, LocationStrategy} from '@angular/common';

@Injectable({providedIn: 'root'})
export class EnvironmentService {

    private sEnvironnement: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    private environnement$: Observable<string>;

    constructor(@Inject(DOCUMENT) private readonly document: any,
                private readonly locationStrategy: LocationStrategy) {
        this.environnement$ = this.sEnvironnement.asObservable();
    }

    public get environnement(): Observable<string> {
        return this.environnement$;
    }

    public get currentEnvironnement(): string {
        if (!this.sEnvironnement.value) {
            this.checkEnvironnement();
        }
        return this.sEnvironnement.value;
    }

    public setEnvironnement(env: string) {
        this.sEnvironnement.next(env);
    }

    public checkEnvironnement() {
        let currentUrl = this.document.location.origin;
        if (currentUrl.indexOf('formation') !== -1) {
            this.sEnvironnement.next('formation');
        } else {
            this.sEnvironnement.next('nominal');
        }
    }

    public getCurrentUrl(): string {
        return this.document.location.origin;
    }

    public getCurrentHostName(): string {
        return this.document.location.hostname;
    }

    public getCurrentPort(): string {
        return this.document.location.port;
    }

    public isFormationEnv(): boolean {
        if (!this.sEnvironnement.value) {
            this.checkEnvironnement();
        }
        return this.sEnvironnement.value && this.sEnvironnement.value === 'formation';
    }

}